import { ca } from '@fullcalendar/core/internal-common';
import { IObject } from 'src/app/models/+global';
import { ITaskCommandWrapper } from "src/app/services/task/task.state.models";
import { ITypeQualificationReason } from 'src/app/shared/interview-new/models/interview-handler.models';

export interface IIntegratorTaskCommandWrapper extends ITaskCommandWrapper {
    type: string;
}
export interface ITaskOrchestratorStateModel {
    context: ITaskOrchestratorContext;
    currentTaskId?: string;
    nextTaskId?: string;

}

export interface ITaskOrchestratorContext {
    title: string;
    tasks: IOrchestratorTask[];
}

export interface IOrchestratorTask {
    id: string;
    command: string;
    type: string;

    overview: IOrchestratorTaskOverview;
    summary: OrchestratorTaskSummary;
    title: string;
    subtitle: string;
    tooltip: string;
    active: boolean;
    required: boolean;
    status: IOrchestratorTaskStatus,
    metadata?: any;
    name?: string;
    readonly $filterProp: string;

}

export class OrchestratorTask implements IOrchestratorTask {
    id: string;
    command: string;
    type: string;
    entityId: string;
    entityType: string;
    overview: IOrchestratorTaskOverview;
    summary: OrchestratorTaskSummary;
    title: string;
    subtitle: string;
    tooltip: string;
    active: boolean;
    required: boolean;

    status: IOrchestratorTaskStatus;
    metadata?: any;
    name?: string

    $internalMetadata: {
        filterProp?: string;

    } = {};
    $filterProp: string;
    constructor(input: IOrchestratorTask) {
        Object.assign(this, input);
        this.processStyling();
    }

    private processStyling() {
        this.$internalMetadata.filterProp = `${this.title} ${this.subtitle} ${this.tooltip} ${this.status?.value} ${this.status?.tooltip} ${this.status?.date}`;

        switch (this.type) {
            case OrchestratorTaskType.interview:
                this.processStylingForInterview();
                break;
            case OrchestratorTaskType.component:
                this.processStylingForComponent();
                break;
        }
    }
    processStylingForComponent() {

    }

    processStylingForInterview() {
        const metadata = this.metadata as IOrchestratorTaskInterviewMetadata;
        const internalMetadata = this.$internalMetadata as IOrchestratorTaskInterviewInternalMetadata

        internalMetadata.completionValue = metadata?.progress?.completion || 0;

        if (metadata?.result) {

            internalMetadata.interviewStatusIcon = this.getStatusIcon(metadata.result.status);
            internalMetadata.interviewStatusClass = this.getInterviewStatusClass(metadata.result.status);
            internalMetadata.reasons = metadata.result.reasons?.map(reason => ({
                status: reason.status,
                statusIcon: this.getStatusIcon(reason.status)
            }));
        }
    }

    private getInterviewStatusClass(status?: string) {
        switch (status?.toUpperCase()) {
            case 'DISQUALIFIED':
                return 'tw-text-red-50 tw-bg-red-500';

            case 'QUALIFIED':
                return 'tw-text-green-50 tw-bg-green-500';

            case 'UNKNOWN':
                return 'tw-text-gray-50 tw-bg-gray-500';
            default: return '';
        }
    }

    private getStatusIcon(status: string) {
        switch (status?.toUpperCase()) {

            case 'DISQUALIFIED':
                return 'fas fa-circle-xmark tw-text-red-500';

            case 'QUALIFIED':
                return 'fas fa-circle-check tw-text-green-500';

            case 'UNKNOWN':
                return 'fas fa-circle-question tw-text-gray-500';
            default: return '';

        }
    }
}





export interface IOrchestratorTaskStatus {
    value: string;
    icon: string;
    date: Date;
    tooltip: string;
}

export interface IOrchestratorTaskOverview {
    class?: string;
    icon: string;
    tooltip?: string;
}

export interface IOrchestratorTaskInterviewMetadata {
    result: {
        status: "Qualified" | "Disqualified",
        reasons: ITypeQualificationReason[]
    },
    progress: {
        completion: number;
        lastUpdatingUser: any;
    }
}

export interface IOrchestratorTaskInternalMetadata {

}
export interface IOrchestratorTaskInterviewInternalMetadata extends IOrchestratorTaskInternalMetadata {
    completionValue: number;
    interviewStatusIcon?: string;
    interviewStatusClass: string;
    reasons: { status: string; statusIcon: string; }[];
}


export declare type OrchestratorTaskSummary = IOrchestratorTaskSummary | boolean;

export interface IOrchestratorTaskSummary extends IObject { }

export enum OrchestratorTaskType {
    interview = 'INTERVIEW',
    component = 'COMPONENT'
}
